import cookies from 'cookiesjs';
import config from '../config/config';
const PFPT_TOKEN = 'pfpt_token';


export function setCookie( name, value ){
    cookies( { [name]: value }, {
        domain: config.COOKIE_DOMAIN,
        expires: false
    } );
}

export function getCookie( name ){
    return cookies( name, {
        domain: config.COOKIE_DOMAIN,
    } );
}

export function clearCookie( name ){
    return cookies( { [name]: null }, {
        domain: config.COOKIE_DOMAIN,
    } );
}

export function getJwtCookie(){
    return getCookie( PFPT_TOKEN );
}

export function setJwtCookie( token ){
    return setCookie( PFPT_TOKEN, token );
}

export function clearJwtCookie(){
    return clearCookie( PFPT_TOKEN );
}
